import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { NotinoLabelRegular500, screenReaderOnly, truncate } from '../../styles/helpers'

const formFieldLabelStyles = css<{ $required?: boolean; $screenReaderOnly?: boolean }>`
	${NotinoLabelRegular500};
	color: ${theme.color.text.primary};
	position: relative;
	${truncate};
	padding: 0;

	${({ $screenReaderOnly }) => $screenReaderOnly && screenReaderOnly}

	${({ $required }) =>
		$required &&
		css`
			&::after {
				display: inline;
				${NotinoLabelRegular500};
				content: '*';
				color: ${theme.color.text.highlight};
				margin-left: 2px;
			}
		`}
`

export const FormFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
`

export const FormFieldset = styled.fieldset`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
	margin: 0;
	padding: 0;
	border: none;
	min-width: 0;
`

export const FormFieldLegend = styled.legend<{ $required?: boolean; $screenReaderOnly?: boolean }>`
	${formFieldLabelStyles};

	${({ $screenReaderOnly }) =>
		$screenReaderOnly
			? null
			: css`
					float: left;
					width: 100%;

					& + * {
						clear: both;
					}
				`}
`
